const Transloadit = {
  AccountKey: process.env.REACT_APP_TRANSLOADIT_ACCOUNT_KEY,
  ImageUploadTemplateId: process.env.REACT_APP_TRANSLOADIT_IMAGE_UPLOAD_TEMPLATE_ID,
  FileUploadTemplateId: process.env.REACT_APP_TRANSLOADIT_FILE_UPLOAD_TEMPLATE_ID,
  S3BucketUrl: process.env.REACT_APP_UPLOAD_DESTINATION_BUCKET,
};

export default Transloadit;



// WEBPACK FOOTER //
// ./src/config/uploadKeys.js